export default "__VITE_ASSET__vgdr5uIq__"